import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { X } from 'lucide-react'
import { Button } from '../Button'

export type FilterDrawerProps = {
  open: boolean
  setOpen: (open: boolean) => void
  children: ReactNode
}

export function FilterDrawer (props: FilterDrawerProps) {
  const { open, setOpen, children } = props
  const { t } = useTranslation()
  return (
    <div className={clsx('fixed flex flex-row top-0 right-0 w-full h-full transition-transform transform  z-10', open && 'translate-x-0', !open && 'translate-x-full')}>
      <div className='absolute top-0 right-0 h-full w-[400px] bg-white shadow-lg'>
        <div className="p-4">
          <h2 className="text-xl font-semibold mb-4 w-full">{t('filters:Filters')}</h2>
          {children}
        </div>
        <Button
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 bg-transparent text-gray-600 border-0 "
          circle
          ghost
        >
          <X />
        </Button>
      </div>
      <div className='absolute top-0 right- w-[calc(100%-400px)] h-full bg-black opacity-20' onClick={() => setOpen(false)}></div>
    </div>
  )
}
